import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let trustedSwiperWr = document.querySelectorAll('.trusted-swiper-wr');

trustedSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true,
      observeParents: true,
      spaceBetween: 0,
      slidesPerView: 1.08,
      threshold: 10,
      centeredSlides: true,
      loop: slidesCount > 4 && window.innerWidth < 640,
      loopedSlides: 4,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 0,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 0,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 0,
          centeredSlides: false,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });
    swiperObserver(swiper);
  }
});